import React, { useEffect, useState } from "react";
import axios from "axios";
import "./SellerContractPage.css";
import star from "../../assets/con-star.png";
import { BaseUrl } from "../../App";
import SellerServicesUrl from "../../SellerServicesUrl";

export default function SellerContractPage() {

  const [activeTab, setActiveTab] = useState("contract");
  const [period, setPeriod] = useState(3);
const [agreeRenew, setAgreeRenew] = useState(false);

  // const sellerToken = localStorage.getItem("seller_token");

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [loading, setLoading] = useState(false);
const [renewLoading, setRenewLoading] = useState(false);
// const [showRenewModal, setShowRenewModal] = useState(false);
const [rates, setRates] = useState([]);
const [average, setAverage] = useState(0);
  /* ===== FETCH PLAN DETAILS ===== */
   const token = localStorage.getItem("token");

// const handleRenew = async () => {
//   try {
//     setRenewLoading(true);

//     const res = await axios.get(
//       BaseUrl + SellerServicesUrl.GetPlans,
//       {
//         headers: {
//           Accept: "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//       }
//     );

//     if (res.data?.status === 200) {
//       setShowRenewModal(true);
//     }

//   } catch (err) {
//     console.log("RENEW ERROR", err);
//   } finally {
//     setRenewLoading(false);
//   }
// };

const handleRenew = async () => {
  try {
    setRenewLoading(true);

    const res = await axios.post(
      BaseUrl + "user/auth/saller-renew-plan",
      {

  period: Number(period),
  platform: "web",

      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      }
    );

    console.log("RENEW RESPONSE", res.data);

    if (res.data?.status === 200) {

      const checkoutUrl =
        res.data?.data?.checkout_url;
        console.log(res.data);

      if (checkoutUrl) {
        window.location.href =
          checkoutUrl;
      }
      
        else {
  alert("لم يتم الحصول على رابط الدفع");

      }
    }

  } catch (err) {
    console.log("RENEW ERROR", err);
  } finally {
    setRenewLoading(false);
  }
};

useEffect(() => {
  const fetchPlan = async () => {
    try {
      setLoading(true);

      const token = localStorage.getItem("token");

      const res = await axios.get(
        BaseUrl + "user/auth/saller-plan-details",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (res.data?.data) {
        setStartDate(res.data.data.start);
        setEndDate(res.data.data.end);
      }

    } catch (err) {
      console.log("PLAN ERROR", err);
    } finally {
      setLoading(false);
    }
  };

  fetchPlan();
}, []);
useEffect(() => {
  const fetchRates = async () => {
    try {
      const res = await axios.get(
        BaseUrl + "user/saller-rates",
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json"
          }
        }
      );

 if (res.data?.data) {
  const data = res.data.data;

  // إجمالي عدد التقييمات
  const totalCount = data.reduce((sum, item) => sum + item.count, 0);

  // نحسب percentage صح
  const normalized = data.map(item => ({
    ...item,
    percentageNumber: totalCount
      ? Math.round((item.count / totalCount) * 100)
      : 0
  }));

  setRates(normalized);

  let total = 0;
  normalized.forEach(item => {
    total += item.rate * item.count;
  });

  setAverage(totalCount ? (total / totalCount).toFixed(1) : 0);
}

    } catch (err) {
      console.log("RATES ERROR", err);
    }
  };

  fetchRates();
}, []);
  if (loading) {
    return (
      <div className="orders-loader text-center py-5 mt-5" style={{minHeight:"100vh",marginTop:"100px"}}>
        <div className="loader-circle mb-3 mt-5 "></div>
        <p className="fw-bold">جاري تحميل التفاصيل...</p>
      </div>
    );
  }

  return (
    <div className="contract-page container pt-4 mt-5">

      {/* ==== Tabs Header ==== */}
      <div className="tabs-header mt-5 mb-5 pt-5 pb-5">
        <button
          className={activeTab === "contract" ? "tab active" : "tab"}
          onClick={() => setActiveTab("contract")}
        >
          التعاقد
        </button>

        <button
          className={activeTab === "rates" ? "tab active" : "tab"}
          onClick={() => setActiveTab("rates")}
        >
          التقييمات
        </button>

        <div className={`tab-indicator ${activeTab}`}></div>
      </div>

      {/* ===== Contract Content ===== */}
      {activeTab === "contract" && (
        <div className="contract-section fade-animation">

          {loading ? (
            <p>جاري تحميل البيانات...</p>
          ) : (
            <>
              <div className="date-box input-inline">
                <div className="date-inline-content">
                  <span className="date-label-inline">تاريخ التعاقد:</span>
                  <span className="date-value-inline">
                    {startDate || "-"}
                  </span>
                </div>
              </div>

              <div className="date-box input-inline">
                <div className="date-inline-content">
                  <span className="date-label-inline">تاريخ الانتهاء:</span>
                  <span className="date-value-inline">
                    {endDate || "-"}
                  </span>
                </div>
              </div>
<div className="renew-check">
    <input
    type="checkbox"
    checked={agreeRenew}
    onChange={() =>
      setAgreeRenew(!agreeRenew)
    }
  />
  <label>
    طلب تجديد
  </label>


</div>

{agreeRenew && (
  <select
    value={period}
    onChange={(e) =>
      setPeriod(e.target.value)
    }
    className="renew-select"
  >
    <option value="3">3 شهور</option>
    <option value="6">6 شهور</option>
    <option value="12">سنة </option>
  </select>
)}
<button
type="button"
  className="renew-btn "
  onClick={handleRenew}
  disabled={!agreeRenew || renewLoading}
>
  {renewLoading
    ? "جارٍ التحويل..."
    : "طلب تجديد"}
</button>
              {/*\ <button className="renew-btn">طلب تجديد</button> */}
  {/* <button
  className="renew-btn"
  onClick={handleRenew}
  disabled={renewLoading}
>
  {renewLoading ? "جارٍ الإرسال..." : "طلب تجديد"}
</button> */}

            </>
          )}
        </div>
      )}
      {/* {showRenewModal && (
  <div className="renew-modal">
    <div className="renew-modal-box">
      <h3>طلب تجديد</h3>
      <p>تم إرسال طلب التجديد بنجاح</p>
     <div className="modal-buttons">
        <button
    className="sellercon btn-primary"
    onClick={() => setShowRenewModal(false)}
  >
    نعم
  </button>
  <button
    className=" btn-outline"
    onClick={() => setShowRenewModal(false)}
  >
    لا
  </button>


</div>

    </div>
  </div>
)} */}

      {/* ===== Ratings Content ===== */}
    {activeTab === "rates" && (
  <div className="rates-section fade-animation">
    <div className="rate-box">

      <div className="rate-header">
        <h1>التقييم العام</h1>
        <div className="rate-number">
         {average}  <img src={star} alt="star"  /> 
        </div>
      </div>

    {rates
  .sort((a, b) => b.rate - a.rate)
  .map((item) => (
    <div className="rate-row" key={item.rate}>

      <span className="rate-percentage">
        {item.percentageNumber}%
      </span>

      <div className="rate-progress">
        <span
          style={{
            width: `${item.percentageNumber}%`
          }}
        ></span>
      </div>

      <span className="rate-label fw-bold">
         ⭐ {item.rate}
      </span>

    </div>
))}

    </div>
  </div>
)}


    </div>
  );
}